<template>
  <select
      :value="value"
      @change="$emit('input', $event.target.value)">
    <slot/>
  </select>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    value: String,
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

$down-arrow: url('data:image/svg+xml,\
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23fff" width="24">\
    <path d="M16.6 8.6L12 13.2 7.4 8.6 6 10l6 6 6-6-1.4-1.4z"/>\
  </svg>');
$up-arrow: url('data:image/svg+xml,\
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23fff" width="24">\
    <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"/>\
  </svg>');
$down-arrow-disabled: url('data:image/svg+xml,\
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23fff6" width="24">\
    <path d="M16.6 8.6L12 13.2 7.4 8.6 6 10l6 6 6-6-1.4-1.4z"/>\
  </svg>');

@mixin background($background-color, $arrow) {
  background-color: $background-color;
  background-image: $arrow;
  background-position: calc(100% - 0.375rem) center;
  background-repeat: no-repeat;
}

select {
  @include background($button-background, $down-arrow);
  appearance: none;
  border-radius: 0.25rem;
  border: none;
  font-size: 1rem;
  line-height: 1.25rem;
  outline: none;
  padding: 0.5rem 2.25rem 0.5rem 0.75rem;
  transition: background-color .2s;

  &:disabled {
    @include background($button-background-disabled, $down-arrow-disabled);
    color: $disabled-text;
  }

  &:not(:disabled) {
    &:focus {
      @include background($button-background-focus, $down-arrow);
    }

    &:hover {
      @include background($button-background-hover, $down-arrow);
    }

    &:active {
      @include background($button-background-active, $up-arrow);
    }
  }

  option {
    background: $button-background-active;
  }
}
</style>
